<template>
  <fragment >
    <GameContainer
      :name="$t('games.taixiu')"
      :table-id="'77'"
      :table="'taixiu77'"
      :data="taixiu77"
      :style-object="style77"
      :dealer-name="'Linda'"
      :window-focus="windowFocus"
      @showdetail="showdetail"
    />
  </fragment>
  <!-- <TestComponent :data="xocdia78" :window-focus="windowFocus" /> -->
</template>

<script>
import {mapState} from 'vuex';
import GameContainer from '@components/taixiu/container.vue';
import TestComponent from '@components/taixiu/test.vue';
import { GAME_TYPE } from '@config/constants.js';
import { getFavoriteOrder } from '@utils/favorite.js';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    GameContainer, TestComponent,
  },
  props: {
    windowFocus: { type: Number, default: 0 },
  },
  computed: {
    ...mapState('taixiu', ['taixiu77']),
    ...mapState('favorite', ['order', 'favorite']),
    style77: function(){
      return { order: getFavoriteOrder(this.order, this.favorite, "77") }
    },
  },
  methods: {
    showdetail(val) {
      // console.log('index - showdetail');
      this.$emit('showdetail', { ...val, game: GAME_TYPE.TAI_XIU });
    }
  }
}
</script>

<style>

</style>

